import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import ProductImage from "@/components/ProductImage";
import { products } from "@/mock";

export default function Hero({ onShop, onBundles }) {
  const [colorIdx, setColorIdx] = useState(0);
  const active = products[colorIdx];

  return (
    <section className="relative bg-[#0a0a0a] text-white overflow-hidden">
      {/* Subtle grain overlay */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.06] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.55'/></svg>\")",
        }}
      />

      {/* Radial spotlight behind product */}
      <div
        className="pointer-events-none absolute right-0 top-0 h-full w-1/2 hidden md:block"
        style={{
          background:
            "radial-gradient(60% 60% at 60% 45%, rgba(198,13,13,0.18) 0%, rgba(10,10,10,0) 60%)",
        }}
      />

      <div className="max-w-[1400px] mx-auto px-4 md:px-8 grid md:grid-cols-2 gap-8 md:gap-6 items-center min-h-[600px] md:min-h-[720px] relative">
        {/* Left: copy */}
        <div className="py-14 md:py-20 z-10">
          <div className="inline-flex items-center gap-2 border border-white/15 rounded-full px-3 py-1 mb-6 text-[10px] tracking-[0.28em] uppercase text-white/70">
            <span className="h-1.5 w-1.5 rounded-full bg-[#ff2626]" /> New season drop
          </div>
          <h1 className="font-black leading-[0.92] tracking-tight text-white text-[54px] sm:text-[68px] md:text-[80px]">
            PREMIUM
            <br />
            UNDERGEAR
          </h1>
          <div className="mt-3 text-[#ff2626] font-black tracking-tight text-[28px] sm:text-[34px] md:text-[40px] leading-none">
            FOR MEN WHO KNOW
          </div>
          <p className="mt-6 text-white/70 max-w-md text-[15px] leading-relaxed">
            Signature jacquard waistband. BD leg logo.
            <br />
            All-day comfort where it counts.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              onClick={onShop}
              className="bg-[#c60d0d] hover:bg-[#e11d1d] text-white rounded-none px-8 h-12 tracking-[0.16em] text-[13px] font-bold uppercase"
            >
              Shop Now <ArrowRight size={16} className="ml-2" />
            </Button>
            <Button
              onClick={onBundles}
              variant="outline"
              className="bg-transparent hover:bg-white hover:text-black text-white border-white/40 rounded-none px-8 h-12 tracking-[0.16em] text-[13px] font-bold uppercase"
            >
              Shop Bundles
            </Button>
          </div>

          {/* Color swatches */}
          <div className="mt-10">
            <div className="text-[10px] tracking-[0.24em] uppercase text-white/50 mb-3">
              Color: <span className="text-white ml-1">{active.color}</span>
            </div>
            <div className="flex items-center gap-3">
              {products.map((p, i) => (
                <button
                  key={p.id}
                  onClick={() => setColorIdx(i)}
                  aria-label={p.color}
                  className={`h-9 w-9 rounded-full border-2 transition-all ${
                    i === colorIdx ? "border-[#ff2626] scale-110" : "border-white/25 hover:border-white/60"
                  }`}
                  style={{ backgroundColor: p.swatch }}
                />
              ))}
            </div>
          </div>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-3 text-white/60 text-[11px] tracking-[0.18em] uppercase">
            <span>★★★★★ 4.9 / 12k+ Reviews</span>
            <span className="h-3 w-px bg-white/20" />
            <span>Free US Shipping $75+</span>
          </div>
        </div>

        {/* Right: hero underwear render */}
        <div className="relative flex items-center justify-center min-h-[420px] md:min-h-[680px] py-10 md:py-0">
          {/* Backdrop panel */}
          <div className="absolute inset-x-6 md:inset-x-0 top-8 md:top-16 bottom-8 md:bottom-16 bg-gradient-to-b from-white/[0.04] via-white/[0.02] to-transparent border border-white/10" />

          <div className="relative z-10 w-full max-w-[520px] px-4 h-[380px] md:h-[560px] flex items-center justify-center transition-all duration-500" key={active.id}>
            <ProductImage
              src={active.img}
              alt={`${active.color} boxer brief`}
              className="drop-shadow-[0_40px_60px_rgba(0,0,0,0.6)]"
              fit="contain"
            />
          </div>

          {/* Floating price tag */}
          <div className="hidden md:flex absolute bottom-10 left-2 bg-white text-black px-5 py-3 items-center gap-3 shadow-2xl z-20">
            <span className="font-black text-2xl">
              ${active.price}
            </span>
            <span className="text-[11px] tracking-[0.22em] uppercase text-black/60 border-l border-black/20 pl-3">
              Boxer Brief
              <br />
              Single Pair
            </span>
          </div>

          {/* Feature callouts */}
          <div className="hidden lg:block absolute top-16 right-4 z-20 max-w-[180px]">
            <div className="bg-black/70 backdrop-blur border border-white/10 px-4 py-3">
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#ff2626] font-bold mb-1">
                Jacquard band
              </div>
              <div className="text-[12px] text-white/80 leading-snug">
                Signature woven waistband. No roll. No pinch.
              </div>
            </div>
          </div>
          <div className="hidden lg:block absolute bottom-24 right-4 z-20 max-w-[180px]">
            <div className="bg-black/70 backdrop-blur border border-white/10 px-4 py-3">
              <div className="text-[10px] tracking-[0.22em] uppercase text-[#ff2626] font-bold mb-1">
                BD Leg logo
              </div>
              <div className="text-[12px] text-white/80 leading-snug">
                Embroidered accent on every pair.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
